// css
import '../css/main.less';

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
// import './configureTurbolinks';
import './components/Highslide';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index.js